const getOffsetHeight = (el: HTMLElement | null) => {
    if (!el || typeof !el.offsetHeight !== 'number' || !el.offsetHeight) return 0;
    return el.offsetHeight;
};

const getOverScroll = (el: HTMLElement | null) => {
    const offsetHeight = getOffsetHeight(el);
    if (offsetHeight > 0 && Number.isNaN(offsetHeight)) {
        return offsetHeight / 3;
    }
    return 0;
};

const scrollIntoView = (el: HTMLElement | null, id: string | undefined) => {
    if (el && id) {
        const listRef = el.getBoundingClientRect();
        const focusedEl = el.querySelector(`[data-focused]`) as HTMLLIElement | null;
        if (focusedEl) {
            const focusedRect = focusedEl?.getBoundingClientRect();
            const overScroll = getOverScroll(focusedEl);

            if (focusedRect.bottom + overScroll > listRef.bottom) {
                el.scrollTop = Math.min(
                    focusedEl.offsetTop + focusedEl.clientHeight - el.offsetHeight + overScroll,
                    el.scrollHeight,
                );
            } else if (focusedRect.top - overScroll < listRef.top) {
                el.scrollTop = Math.max(focusedEl.offsetTop - overScroll, 0);
            }
        }
    }
};

export default scrollIntoView;
